import { useGetIndividualResultQuery } from '../state/api';
import IndividualResultTable from './individual-result-table';

interface IndividualResultTableContainerProps {
  comp_id: string | null | undefined;
}

const IndividualResultTableContainer = ({ comp_id }: IndividualResultTableContainerProps) => {
  const { data: results = [] } = useGetIndividualResultQuery(comp_id!, {
    skip: comp_id == null,
  });

  return <IndividualResultTable results={results} />;
};

export default IndividualResultTableContainer;
